import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MarketplaceCategoryProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `MarketplaceCategory/${props.marketplaceCategoryId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `MarketplaceCategory`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MarketplaceCategory/${props.marketplaceCategoryId}`, method: 'PUT', payload: props, multipart: true, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'MarketplaceCategory', method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `MarketplaceCategory/${props.marketplaceCategoryId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMarketplaceCategoryStore = () => React.useContext(Context);
